module.exports = __webpack_public_path__ + "img/PG.80251e0f.jpg";